import * as MessageShared from "../../darvin-shared/schema/zod/agent/message-types.schema";
import type { ProjectChatAssistantMessage } from "../view_stores/chat_messages/chatModels";

/**
 * Type guard to check if a value is an ErrorContent type
 */
export function isErrorContent(
  value: ProjectChatAssistantMessage["value"]
): value is MessageShared.ErrorContent {
  return (
    typeof value === "object" &&
    value !== null &&
    "type" in value &&
    (value.type === "compilation" ||
      value.type === "technical" ||
      value.type === "fatal" ||
      value.type === "rollback")
  );
}

/**
 * Type guard to check if a value is a rollback error with rollbackDetails
 */
export function isRollbackError(
  value: ProjectChatAssistantMessage["value"]
): value is Extract<MessageShared.ErrorContent, { type: "rollback" }> {
  return (
    isErrorContent(value) &&
    value.type === "rollback" &&
    "rollbackDetails" in value
  );
}
